import { createAsyncThunk } from '@reduxjs/toolkit'
import { invoiceManagementAPI } from '@services/api'

export const fetchInvoiceManagementList = createAsyncThunk(
  'invoiceManagement/fetchInvoiceManagementList',
  async (params: TInvoiceManagementAPI.Params.list, { rejectWithValue }) => {
    try {
      const response = await invoiceManagementAPI.fetchList(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchInvoiceManagementListForExcel = createAsyncThunk(
  'invoiceManagement/fetchInvoiceManagementListForExcel',
  async (params: any, { rejectWithValue }) => {
    try {
      const response = await invoiceManagementAPI.fetchList(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const fetchDetailHistory = createAsyncThunk(
  'invoiceManagement/fetchDetailHistory',
  async (InvoiceId: string, { rejectWithValue }) => {
    try {
      const response = await invoiceManagementAPI.fetchDetailHistory(InvoiceId)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const createInvoiceHistory = createAsyncThunk(
  'invoiceManagement/createInvoiceHistory',
  async (params: TInvoiceManagementAPI.Params.createHistory, { rejectWithValue }) => {
    try {
      const response = await invoiceManagementAPI.createInvoiceHistory(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)
